import type React from 'react'
import type { JSX } from 'react'
import type { DoubleRowContainerPadding } from './DoubleRowContainer.h'

import { DoubleRowContainerStyled } from './DoubleRowContainerStyled.styled'

export interface IDoubleRowContainerProps {
  children: React.ReactNode
  paddings?: DoubleRowContainerPadding
}

export const DoubleRowContainer = ({
  children,
  paddings,
}: IDoubleRowContainerProps): JSX.Element => (
  <DoubleRowContainerStyled paddings={paddings}>
    {children}
  </DoubleRowContainerStyled>
)
